//@ts-check
import { testCategoryGroupColors, colors } from 'shared-ui'

export default function getTestCategoryGroupColor(testCategoryGroup) {
    return testCategoryGroupColors[testCategoryGroup] || colors.super
}
